// extracted by mini-css-extract-plugin
export default {"systemHeaderFields":"SystemHeaderFields_systemHeaderFields__biMig","countField":"SystemHeaderFields_countField__CGnJY","warningMessage":"SystemHeaderFields_warningMessage__o5IJc"};